export enum LoginEnum {
  Token = "token",
}
